let currentAuthToken = readStoredAuthToken();

export function readStoredAuthToken() {
  try {
    return JSON.parse(localStorage.getItem("token"));
  } catch {
    return null;
  }
}

export function getCurrentAuthToken() {
  return currentAuthToken;
}

export function setCurrentAuthToken(token) {
  currentAuthToken = token;

  if (token) {
    localStorage.setItem("token", JSON.stringify(token));
  } else {
    localStorage.removeItem("token");
  }

  return currentAuthToken;
}
